module.exports = __webpack_public_path__ + "static/scale-model-of-florida-holocaust-museum-in-st.-petersburg-florida-3ca90b6fe10812d9bedd23e8c8dd4b7a.png";